import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import LocationsTableContainer from '../../../modules/locations/components/LocationsTableContainer';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import { hasPermission } from '../../../utils/HelperFunctions';
import Button from '../../../components/buttons/Button';

const Locations = () => {
  const { t } = useTranslation();

  const { apiData, apiDataLoading, paginationEle, searchEle } = useModuleTableHelpers({
    route: 'admin/locations',
    withBreadcrumb: true,
    withSearch: true,
    breadcrumbTitle: t('links.locations'),
    withPagination: true,
    queryKey: 'locations',
    customSearchPlaceholder: `${t("search_by")} ${t("name")} ${t("or")} ${t("code")}`
  });

  const tableHeaders = [
    { label: t('name') },
    { label: t('is_service_center') },
    { label: `${t('hide')} (${t('active_means_hide')})` },
    hasPermission(['locations.edit']) && { label: t('actions'), customClass: 'actions_col' }
  ];

  if (apiDataLoading && !apiData) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="locations-page-container">
      <ListHeader customClass='table_filters'>
        <div className="filter_container">
          {searchEle}
        </div>
        {hasPermission(['locations.edit']) && <Button text={t('create_location')} link="/locations/create-location" />}
      </ListHeader>
      <LocationsTableContainer tableHeaders={tableHeaders} data={apiData} noDataMessage={t('no_locations_found')} lessColumns />
      {paginationEle}
    </div>
  );
};

export default Locations;
